// extracted by css-extract-rspack-plugin
export default {"loadingState":"loadingState-nRbKBV","loadingCenter":"loadingCenter-ORo76c","loadingLabel":"loadingLabel-qNj7Tr"};